import { render } from "./ERPBoard.vue?vue&type=template&id=606f6387"
import script from "./ERPBoard.vue?vue&type=script&lang=js"
export * from "./ERPBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__